<template>
    <div v-if="property_analysis.custom_unit_id_for_zk" class="m-t-10">
        <div style="cursor: pointer; user-select: none; gap: 6px;" @click="toggle" class="m-b-5 d-flex align-items-center">
            <i class="fa fa-sm" :class="collapsed ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
            {{ $t("legal:share_selector:title") }}
        </div>
        <div v-show="!collapsed" class="vld-parent collapse-content" :class="{ 'collapse-loading': loading }">
            <loading
                :active="loading"
                :can-cancel="false"
                :is-full-page="false"
                :height="30"
            />

            <div v-if="errorMsg" class="alert alert-warning">
                {{ errorMsg }}
            </div>

            <div v-if="availableShares.length > 0">
                <div
                    v-for="share in availableShares"
                    :key="share.lrUnitShareId"
                    class="share-checkbox"
                >
                    <label class="d-flex align-items-center" style="gap: 6px;">
                        <input
                            type="checkbox"
                            :value="share.lrUnitShareId"
                            v-model="selectedShareIds"
                        />
                        <span>
                            {{ share.ownersDisplay }}
                            <span v-if="share.description" class="text-muted m-l-5">
                                ({{ share.description }})
                            </span>
                        </span>
                    </label>
                </div>

                <button
                    class="btn btn-info btn-sm m-t-10"
                    :disabled="saving"
                    @click="saveAndRebuild"
                >
                    <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                    {{ $t("legal:share_selector:fetch") }}
                </button>
            </div>

            <div v-else-if="!loading && !errorMsg">
                {{ $t("task_details:status:no_data") }}
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import ApiService from "@/components/utils/api.service.js";

export default {
    name: "LegalShareSelector",
    components: {
        Loading,
    },
    props: {
        property_analysis: {
            type: Object,
            required: true,
        },
        session_id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            saving: false,
            collapsed: true,
            hasFetched: false,
            errorMsg: null,
            availableShares: [],
            selectedShareIds: [],
        };
    },
    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
            if (!this.collapsed && !this.hasFetched) {
                this.fetchAvailableShares();
            }
        },
        async fetchAvailableShares() {
            this.loading = true;
            this.errorMsg = null;
            try {
                const response = await ApiService.get(
                    `/amas/real-estate/api/geoportal-for-ldb-extract/${this.property_analysis.custom_unit_id_for_zk}/`
                );
                var data = response.data || {};
                var ownershipSheetB = data.ownershipSheetB || {};
                const lrUnitShares = ownershipSheetB.lrUnitShares || [];
                this.availableShares = lrUnitShares.map((share) => {
                    const ownersDisplay = (share.lrOwners || [])
                        .map((o) => o.name)
                        .filter(Boolean)
                        .join(", ");
                    return {
                        lrUnitShareId: share.lrUnitShareId,
                        ownersDisplay: ownersDisplay || "-",
                        description: share.description || "",
                    };
                });

                // Pre-select shares matching current custom_share_id_for_zk
                if (this.property_analysis.custom_share_id_for_zk) {
                    const currentIds = this.property_analysis.custom_share_id_for_zk
                        .split(",")
                        .map((s) => s.trim());
                    this.selectedShareIds = currentIds.filter((id) =>
                        this.availableShares.some((s) => String(s.lrUnitShareId) === id)
                    );
                }
                this.hasFetched = true;
            } catch (err) {
                var errResponse = (err && err.response) || {};
                var errData = errResponse.data || {};
                this.errorMsg =
                    errData.detail ||
                    (err && err.message) ||
                    this.$t("task_details:status:no_data");
            } finally {
                this.loading = false;
            }
        },
        async saveAndRebuild() {
            this.saving = true;
            try {
                const shareValue =
                    this.selectedShareIds.length > 0
                        ? this.selectedShareIds.join(",")
                        : null;
                const response = await ApiService.put(
                    `/amas/analysis/analysis/api/${this.session_id}/legal-status`,
                    {
                        property_analysis_id: this.property_analysis.id,
                        custom_share_id_for_zk: shareValue,
                    }
                );
                this.$emit("shares-updated", response.data);
            } catch (err) {
                var errResponse = (err && err.response) || {};
                var errData = errResponse.data || {};
                this.errorMsg =
                    errData.detail ||
                    (err && err.message) ||
                    this.$t("legal:fetch:error");
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.share-checkbox input[type="checkbox"] {
    width: 14px;
    height: 14px;
    cursor: pointer;
}
label {
    font-weight: normal;
}

.collapse-content {
    font-size: 14px;
    margin-left: 20px;
}
.collapse-loading {
    height: 40px;
}
</style>
